import React from 'react';
import { PersistGate as OrigPeristGate } from 'redux-persist/integration/react';
import { Loading } from '../../../scenes/Loading';

export type PersistGateProps = { persistor: any };

export const PersistGate = ({ children, persistor }: React.PropsWithChildren<PersistGateProps>) => {
    return (
        <OrigPeristGate persistor={persistor} loading={<Loading />}>
            {children}
        </OrigPeristGate>
    );
};
